import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import t from '../../../lib/I18n';

import OnEnterTrigger from '../../general/OnEnterTrigger';
import StarIcon from '../../icons/StarIcon';
import RewardPointsModal from '../../fares/details/RewardPointsModal';

const RewardPointsEarned = ({ rewardPoints, className }) => {
    const [modalVisible, setModalVisible] = useState(false);

    if (!rewardPoints) {
        return null;
    }

    return (
        <div className={cn('reward-points__container', className)}>
            <StarIcon />
            <div className="reward-points__container__content">
                <p>{t('rewardPoints.earned.pointsAmount', { rewardPoints })}</p>

                <OnEnterTrigger
                    onClick={e => {
                        e.stopPropagation();
                        setModalVisible(true);
                    }}
                    className="like-link"
                >
                    {t('rewardPoints.earned.findOutMore')}
                </OnEnterTrigger>
            </div>
            {modalVisible && (
                <span onClick={e => e.stopPropagation()}>
                    <RewardPointsModal onClose={() => setModalVisible(false)} />
                </span>
            )}
        </div>
    );
};

RewardPointsEarned.propTypes = {
    rewardPoints: PropTypes.number.isRequired,
    className: PropTypes.string,
};

export default React.memo(RewardPointsEarned);
